import React, { useEffect, useState } from "react";
import { Form, Input, Button, notification } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { post } from "../../../api/axios";

const Login = () => {
    const [loading, setLoading] = useState(false);

    const [loginData, setLoginData] = useState({ email: "", password: "" });

    const handleChange = (e) => {
        setLoginData({ ...loginData, [e.target.id]: e.target.value });
    };


    useEffect(() => {
        const loggedInAdmin = localStorage.getItem("loggedInAdmin");
        if (loggedInAdmin) {
            window.location.href = "/";
        }
    }, []);

    const onFinish = (values) => {
        setLoading(true);

        post("auth/login", loginData)
            .then((res) => {
                notification.success({message:"You are logged in"});
                localStorage.setItem("tokenAdmin", res.data.credentials.access_token);
                localStorage.setItem(
                    "permissionsAdmin",
                    JSON.stringify(res.data.profile.permissions)
                );
                localStorage.setItem("loggedInAdmin", true);
                localStorage.setItem("authDataAdmin", JSON.stringify(res.data.profile));


                const lastPaht = localStorage.getItem('lastPath')

                lastPaht ? window.location.href = lastPaht : window.location.href = ''


            })
            .catch((err) => {
                notification.error({
                    message: err.response.data.message,
                    description: "The email or password is incorrect",
                });
                setLoading(false);
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const validateUsername = (_, value) => {
        if (!value) {
            return Promise.reject("This field is required!");
        } else {
            return Promise.resolve();
        }
    };

    const validatePassword = (_, value) => {
        if (!value) {
            return Promise.reject("This field is required!");
        } else {
            return Promise.resolve();
        }
    };

    return (
        <div className="login-section">
            <section className="ftco-section">
                <div className="container">
                    <div className="row justify-content-center mt-5">
                        <div className="col-md-7 col-lg-5">
                            <div className="login-wrap p-4 p-md-5">
                                <div className="icon d-flex align-items-center justify-content-center">
                                    <UserOutlined />
                                </div>
                                <h3 className="text-center mb-4"> Login </h3>
                                <Form
                                    className="login-form"
                                    layout="vertical"
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                >
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[{ validator: validateUsername }]}
                                        onChange={handleChange}
                                    >
                                        <Input size="large" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Password "
                                        name="password"
                                        rules={[{ validator: validatePassword }]}
                                        onChange={handleChange}
                                    >
                                        <Input.Password size="large" />
                                    </Form.Item>
                                    <Form.Item>
                                        <Button
                                            className="form-control btn btn-primary rounded submit px-3"
                                            type="primary"
                                            block
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            {loading ? "Logging in..." : "Submit"}
                                        </Button>
                                    </Form.Item>
                                </Form>
                                {/* <Link to='/forget-password'> Forget Password </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Login;
